import { html as t } from "@microsoft/fast-element";
const a = t`
  <div class="control" part="control">
    <div class="step-container">
      <div class="step-head">
        <span class="step-label"> ${(s) => s.label} </span>
        <slot name="hint"></slot>
      </div>
      <slot class="step-content"></slot>
    </div>
  </div>
`;
export {
  a as stepTemplate
};
